import { useEffect } from "react";
import { useRouteError } from "react-router";

import { avisarError } from "@/lib/registro-de-errores";

/**
 * Una pantalla en blanco no dice nada: esto al menos dice qué pasó. Y el fallo llega al registro de
 * errores del ERP (0182) para que el owner lo vea sin que nadie tenga que avisarle.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : "Error inesperado";
  useEffect(() => {
    if (error instanceof Error) avisarError("screen", error);
  }, [error]);
  return (
    <div role="alert" className="mx-auto max-w-prose p-8">
      <h1 className="text-xl font-bold text-light">La pantalla no cargó</h1>
      <p className="mt-2 text-light-2">{message}</p>
      <p className="mt-2 text-light-2">Recarga la página. Si se repite, avisa a soporte con la hora exacta.</p>
    </div>
  );
}
